import type { PaymentResult } from '@/types/payment';

function getTopWindow(): Window {
  try {
    return window.top ?? window;
  } catch {
    return window;
  }
}

export function followPaymentConfirmation(result: PaymentResult): void {
  if (!result.confirmUrl) {
    return;
  }

  if (result.confirmMethod === 'POST') {
    submitPostForm(result.confirmUrl, result.confirmParams ?? {});
    return;
  }

  getTopWindow().location.assign(result.confirmUrl);
}

function submitPostForm(action: string, params: Record<string, string>): void {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = action;
  form.target = '_top';
  form.style.display = 'none';

  for (const [name, value] of Object.entries(params)) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  document.body.appendChild(form);
  form.submit();
}
